
import { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Dashboard from './pages/dashboard';
import Search from './pages/search';
import TestSearch from './pages/testSearch';
import SearchResults from './pages/searchResults';
import IndividualPatient from './pages/individualPatient';
import IndividualPatientTest from './pages/individualPatientTest';
import SignUp from './pages/signup';
import Questionnaire from './pages/Questionnaire';
import PendingEntries from './pages/pendingEntries';
import AssignTest from './pages/assignTest';
import TestFlow from './pages/testflow';
import Results from './pages/results';
import ScreeningTest from './audio/screeningTest';
import HearingTest from './audio/hearingTest';
import Nextsteps from './pages/Nextsteps';
import Qualtrics from './pages/Qualtrics';
import Testcheck from './pages/testcheck';
import { ensureProvidersSynced } from './database/providerSync';
import { PatientProvider } from './context/patientContext';
import InvitationHandler from './components/InvitationHandler';
import TestSearchResults from './pages/testSearchResults';
import ProtectedRoute from './components/ProtectedRoute';
import LanguageToggle from './components/LanguageToggle';
import ReturnToDashboardButton from './components/ReturnToDashboardButton';

import Calibration from './pages/calibration';


function App() {
  // provider directory sync on app load
  useEffect(() => {
    (async () => {
      try {
        await ensureProvidersSynced();
      } catch (err) {
        console.error('Error syncing provider directory:', err);
      }
    })();
  }, []);
  

  return (
    <Router>
      <PatientProvider>
        <LanguageToggle />
        <ReturnToDashboardButton />
        <Routes>
          <Route
            path="/"
            element={
              <InvitationHandler>
                <Dashboard />
              </InvitationHandler>
            }
          />

          <Route
            path="screening"
            element={<ScreeningTest />}
          />

          <Route
            path="calibration"
            element={<Calibration />}
          />

          <Route
            path="hearing"
            element={<HearingTest />}
          />

          {/* Route for new patient signup */}
          <Route
            path="signup"
            element={<SignUp />}
          />

          <Route
            path="dashboard"
            element={<Dashboard />}
          />

          <Route
            path="questionnaire"
            element={<Questionnaire />}
          />

          <Route
            path="pendingEntries"
            element={
              <ProtectedRoute>
                <PendingEntries />
              </ProtectedRoute>
            }
          />

          <Route
            path="assignTest"
            element={<AssignTest />}
          />

          <Route
            path="testflow"
            element={<TestFlow />}
          />

          <Route
            path="testcheck"
            element={<Testcheck />}
          />

          <Route
            path="results/:mode"
            element={<Results />}
          />

          <Route
            path="nextsteps"
            element={<Nextsteps />}
          />

          <Route
            path="qualtrics"
            element={<Qualtrics />}
          />

          <Route
            path="search"
            element={<Search />}
          />

          <Route
            path="testSearch"
            element={<TestSearch />}
          />

          <Route
            path="searchResults"
            element={<SearchResults />}
          />

          <Route
            path="individualPatient"
            element={<IndividualPatient />}
          />

          <Route
            path="individualPatientTest"
            element={<IndividualPatientTest />}
          />
          <Route
            path="testSearchResults"
            element={<TestSearchResults />}
          />

        </Routes>
      </PatientProvider>
    </Router>
  );
}

export default App;
